module.exports = __webpack_public_path__ + "static/img/报告@4x.49f99c6a.png";